export const ConsumerAutoSubmissionMessages = {
  loadingMessage: {
    id: 'Pages.ConsumerAutoSubmission.Retry.loadingMessage',
    description: 'loading message for auto submission retry',
  },
}
